import * as React from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

export const ImageAndText = ({ slice }) => {
  return (
    <div className="container px-0 mb-80px">
      <div className="row mx-0">
        <style>
          {`.h-400-800 {
            height:400px;
          }
          @media (min-width: 992px) {
            .h-400-800 {
              height:800px;
            }
          }`}
        </style>
        <div className="d-none d-lg-block col-12 col-lg-6 px-0" style={{backgroundImage: `url(${slice.primary.img.url})`,backgroundPosition:"center center",backgroundSize:"cover",minHeight:"800px"}}/>
        <div className="col-12 col-lg-6 ps-lg-5 py-lg-5 text-center text-lg-start">
          <h2 className="text-primary mb-4">{slice.primary.title}</h2>
          <div className="mt-4">
            <PrismicRichText field={slice.primary.text.richText} />
          </div>
          <div className="mt-4 mt-lg-5">
            <PrismicRichText field={slice.primary.text_2.richText} />
          </div>
          <div className="d-lg-none my-5" style={{backgroundImage: `url(${slice.primary.img.url})`,backgroundPosition:"center center",backgroundSize:"cover",height:"400px"}}/>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyImageAndText on PrismicHomepageDataBodyImageAndText {
    primary {
      title
      text {
        richText
      }
      text_2 {
        richText
      }
      img {
        url
      }
    }
  }
`
